<template>
<div>
  <div v-if="content" class="card-content-container " :key="id">
    <!-- 상단 헤더: 제목 + 메타 -->
    <header class="content-detail-header">
      <h1 class="content-detail-title">{{ content.title }}</h1>
      <div class="content-detail-meta">
        <span class="meta-left">{{ content.editor || '관리자' }} · {{ displayDate }}</span>
        <span class="meta-right">{{ $t('조회수') }} {{ (content.viewCount || 0).toLocaleString() }}</span>
      </div>
    </header>

    <!-- 썸네일: 제목 밑, 본문 위 -->
    <div v-if="content.image" class="page-thumbnail">
      <img :src="content.image" :alt="content.title" />
    </div>

    <div class="page-contents ql-editor" v-html="content.content">
    </div>

    <div class="content-attachment-wrap" v-if="content.attachment">
      <a target="_blank" :href="content.attachment.url" :download="content.attachment.filename">
        {{content.attachment.filename}} 
        <img alt="download" src="@/assets/image/download.svg" height="16"/>
      </a>
    </div>

    <div v-if="!previewContent" class="content-share-wrap">
      <div class="share-buttons">
        <button class="vhp-button" @click="copyUrl()"><img src="@/assets/image/link.svg" alt="list" height="18" width="18"/></button>
        <div class="like-wrap">
          <button class="vhp-button" @click="like()"><img src="@/assets/image/like.svg" alt="list" height="18" width="18"/></button>
          <span class="like-count">{{ this.content.likeCount || 0 }}</span>
        </div>
      </div>
      <div class="inquiry-btn-wrap">
        <router-link to="/contact" class="vhp-button inquiry-btn">{{ $t('문의하기') }}</router-link>
      </div>
      <div class="prev-next-inline">
        <router-link v-if="content.prevId" :to="{ path: $route.path, query: { ...$route.query, id: content.prevId } }" class="prev-next-link prev">
          {{ $t('이전글') }}
        </router-link>
        <span v-else class="prev-next-link prev empty">{{ $t('이전글') }}</span>
        <router-link v-if="content.nextId" :to="{ path: $route.path, query: { ...$route.query, id: content.nextId } }" class="prev-next-link next">
          {{ $t('다음글') }}
        </router-link>
        <span v-else class="prev-next-link next empty">{{ $t('다음글') }}</span>
      </div>
    </div>

  </div>

  <div v-if="content && !previewContent" class="content-navigator">
      <div class="list-button">
        <button class="vhp-button" @click="goList()">{{ $t('목록보기') }}</button>
      </div>

      <h2>
        <strong>{{ $t(content.category) }}</strong> {{$t('추천글')}}
      </h2>
      
      <div class="featured-list" v-if="featuredListForDisplay && featuredListForDisplay.length > 0">
        <vhp-simple-card 
          v-for="item in featuredListForDisplay"
          :key="item.id"
          :content="item"
          :base-url="featuredBaseUrl"
          :list-url="featuredListUrl"
        />
      </div>  
    </div>
</div>
</template>

<script>
import vhpSimpleCard from '@/components/cards/vhpSimpleCard.vue'
export default {
  name: 'ContentIndex',
  components:{
    vhpSimpleCard
  },
  props:{
    id:{
      type:String,
      default:''
    },
    previewContent: {
      type: Object,
    },
    apiBase: {
      type: String,
      default: '/content'
    }
  },
  data() {
    return {
      content: null,
    }
  },
  computed: {
    displayDate() {
      const raw = this.content && (this.content.editedDate || this.content.createdDate)
      if (raw) {
        if (typeof raw === 'string') return raw.slice(0, 10)
        if (raw.year != null && raw.month != null && raw.day != null)
          return `${raw.year}-${String(raw.month).padStart(2, '0')}-${String(raw.day).padStart(2, '0')}`
        return String(raw)
      }
      const d = new Date()
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    /** 추천글 목록 (백엔드 값 또는 fallback) */
    featuredListForDisplay() {
      return this.content && (this.content.contentFeaturedList || []).filter(Boolean)
    },
    featuredBaseUrl() {
      return this.apiBase === '/api/aiblog' ? '/news/blog-details' : this.$route.path
    },
    featuredListUrl() {
      return this.apiBase === '/api/aiblog' ? '/news/blog' : (this.$route.query.list || '')
    },
  },
  mounted() {
    if(this.id)
      this.getContent(this.id)
    else if(this.previewContent)
      this.content = this.previewContent

    this._onCopy = (e) => {
      e.preventDefault()
      e.clipboardData && e.clipboardData.setData('text/plain', '')
    }
    this._onSelectStart = (e) => { e.preventDefault() }
    this._onContextMenu = (e) => { e.preventDefault() }

    document.addEventListener('copy', this._onCopy)
    document.addEventListener('selectstart', this._onSelectStart)
    document.addEventListener('contextmenu', this._onContextMenu)
  },
  beforeUnmount() {
    document.removeEventListener('copy', this._onCopy)
    document.removeEventListener('selectstart', this._onSelectStart)
    document.removeEventListener('contextmenu', this._onContextMenu)
  },
  watch:{
    id() {
      this.getContent(this.id)
    },
    '$route.query.id'() {
      this.getContent(this.$route.query.id)
    }
  },
  methods:{
    async getContent(id) {
      await this.$axios.get(this.apiBase + '/details', {
        params:{
          id: id
        }
      })
      .then(res=>{
        this.content = res.data
        window.scrollTo(0, 0)
      })
      .catch(err=>{
        console.log(err)
      })
    },
    copyUrl() {
      const val = window.location.href
      this.$utils.copy(val)
      alert('현재 주소가 클립보드에 복사되었습니다.')
    },
    like() {
      this.$axios.post(this.apiBase + '/like',{
        id:this.content.id
      })
      .then(res=>{
        this.content.likeCount = res.data || 0
      })
      .catch(err=>{
        console.log(err)
      })
    },
    goList(tag) {
      let listUrl = this.$route.query.list

      if(!listUrl)
        this.$router.go(-1)
      else {
        let redirectUrl = tag ? listUrl + '?tag=' + tag : listUrl
        this.$router.push(redirectUrl)
      }
    },
  }
}
</script>

<style lang="scss" src="./ContentLayout.scss"></style>
